import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { companyActions } from '../../../modules/company';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import EditPenIcon from '../../assets/imgs/icons/EditPenIcon.svg';
import { SCREEN_SIZES } from '../../constants/screenSizes';
import { ChangeLogoModal } from '../modals';

import { CompanyLogoWrapS, EditPenIconS, LogoWithUploadOverlayS } from './companyEditS';

const { updateCompanyLogo, removeLogo } = companyActions;

const CompanyPhotoUploader = ({ company, isAdmin }) => {
  const dispatch = useDispatch();
  const [isChangeLogoModalOpened, setIsChangeLogoModalOpened] = useState(false);
  const { width: windowWidth } = useWindowSize();

  const handleUpdateLogo = (event) => {
    const formData = new FormData();
    formData.append('logo', event.target.files[0]);
    dispatch(updateCompanyLogo({ _id: company._id, formData }));
    setIsChangeLogoModalOpened(false);
  };

  const handleRemoveLogo = () => {
    dispatch(removeLogo(company._id, isAdmin));
    setIsChangeLogoModalOpened(false);
  };

  return (
    <>
      <ChangeLogoModal
        removeLogo={handleRemoveLogo}
        updateLogo={handleUpdateLogo}
        isModalOpen={isChangeLogoModalOpened}
        toggleModal={setIsChangeLogoModalOpened}
      />

      <CompanyLogoWrapS>
        <LogoWithUploadOverlayS logo={company.logo} onClick={() => setIsChangeLogoModalOpened(true)} />
        {windowWidth <= SCREEN_SIZES.MEDIUM && (
          <EditPenIconS>
            <img src={EditPenIcon} alt="Edit avatar" />
          </EditPenIconS>
        )}
      </CompanyLogoWrapS>
    </>
  );
};

export default CompanyPhotoUploader;
